import { Component, Input } from '@angular/core';

import { FileType } from '../shared/models/file-item.model';
import './recommended-react.component.css';

@Component({
    selector: 'ohp-recommended-react',
    templateUrl: './recommended-react.component.html'
})
export class RecommendedReactComponent {
    @Input() public fileType: FileType;
}
